import styled from 'styled-components'

export const NodeText = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`
